
				var addMethods = require("../../node_modules/workerize-loader-5/dist/rpc-wrapper.js")
				var methods = ["parse","stringify"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "0d8cee73771e993172ad.worker.js", { name: "[fullhash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			